export enum ProfilesViewMode {
  Cards = "cards",
  Table = "table"
}
